import styled from 'styled-components';
import { BHS_PRETO, ESTADO_NEUTRO } from 'constants/cores';

export const FinishWrapper = styled.div`
  width: 100%;
  display: grid;
  gap: 32px;

  h2 {
    color: ${BHS_PRETO};
    font-size: 28px;
    font-weight: lighter;

    small {
      font-size: 20px;
    }
  }

  .finished-text {
    padding: 0 32px;
  }
`;

export const Reasons = styled.div`
  width: 100%;
  display: grid;
  gap: 16px;

  label, textarea {
    width: 100%;
    padding: 16px 32px;
    display: flex;
    align-items: center;
    gap: 16px;

    background-color: #fff;
    border: none;
    border-radius: 8px;
    box-shadow: 0 9px 24px rgba(29, 37, 44, .15);
    cursor: pointer;

    span {
      color: ${BHS_PRETO};
    }
  }

  div {
    display: grid;
    gap: 16px;

    span {
      display: block;
      margin-top: 16px;

      color: ${BHS_PRETO};
    }

    textarea {
      cursor: auto;

      &::placeholder {
        color: ${ESTADO_NEUTRO};
      }
    }
  }
`;
